export default __webpack_public_path__ + "static/media/mishandling-sensitive-information.bbdbe65c.svg";